import { render, staticRenderFns } from "./BlockTeams.vue?vue&type=template&id=a37dcbb2&"
import script from "./BlockTeams.vue?vue&type=script&lang=js&"
export * from "./BlockTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports